// 标题-五点 基本敏感词
const title_describe_base = []
// 虚假/夸大宣传
// const exaggerate = ["Best","Top","Perfect","Number one","100% Guaranteed","Lifetime Warranty","Miracle","Magical",
//     "Revolutionary","Ultimate","Unbeatable"];title_describe_base.push(exaggerate)
// 医疗/健康效果 - FDA Approved(未经认证)
// const health = ["Cure","Treat","Prevent","Heal","Medicine","Drug","Therapy","Diagnosis","FDA Approved","Clinical",
//     "Health","Recovery"];title_describe_base.push(health)
// 价格/促销
// const Promotion = ["Cheap","Discount","Free shipping","Lowest price","Best deal","Buy now","Limited offer","Sale",
//     "Bargain","Promo","Coupon"];title_describe_base.push(Promotion)
// 竞品/平台词汇 - Better than [Brand], Compared to [Brand], Like [Brand]
// const platform = ["eBay","Walmart","AliExpress","Shopify","Better than","Compared to","Like"];title_describe_base.push(platform)
// 时效性/新品 - Seasonal, 2025 New (年份需及时更新)
// const Timeliness = ["New arrival","Latest model","Just released","Limited edition","Seasonal","2025 New"];title_describe_base.push(Timeliness)
// 权限/认证词汇 - FBA (需符合条件)
// const permission = ["Amazon's Choice","Premium","Certified","Official","Licensed","FBA","Genuine","Authentic"];title_describe_base.push(permission)
// 侵权/法律风险 - Samsung (未经授权)
// const infringement = ["OEM","Patented","Copyrighted","Nike","Apple","Samsung","Weapon","CBD","Tobacco","Alcohol"];title_describe_base.push(infringement)
// 宗教/政治/敏感话题
// const sensitive_topics =["Christian","Muslim","Jewish","Political","Government","Military","War","Terror"];title_describe_base.push(sensitive_topics)
// 暴力/危险
// const violence = ["Kill","Explosion","Gun","Knife","Poison","Dangerous","Hazardous"];title_describe_base.push(violence)
// 成人内容 - Lingerie (需符合类目规定)
// const adult_content = ["Sexy","Adult","Erotic","Nude","Lingerie"];title_describe_base.push(adult_content)
// 镇静剂有关
// const calming = ["sedative", "remedy", "hemp", "tranquilizer", "anti-anxiety", "anti-depressant", "sleep aid", "mood stabilizer", "calms hyperactivity", "stress reducer", "non-prescription", "OTC", "drug-free", "works instantly", "fast-acting", "alternative to medication"]
const all_mgc = ["100% natural", "100% quality guaranteed", "Acquired Immune Deficiency Syndrome",
    "ADD", "added value", "ADHD", "AIDS", "All Natural", "ALS", "Alzheimers", "Anti-bacterial",
    "Anti-Fungal", "Anti-Microbial", "anxiety", "approved", "Arrive faster",
    "Attention Deficit Disorder Drug", "Authentic", "award winning", "Anti-mildew", "Anti-mold",
    "Anti-Mites", "Anti-Fouling", "Anti-virus", "Antimicrobial", "Antibacterial", "Antifungal",
    "Anti-toxic", "Anti-flu", "All natural", "Allergens", "Anti-Bacterial vinyl", "bacteria",
    "best deal", "Best price", "Best seller", "Best selling", "big sale", "biodegradable",
    "biological contaminants", "bpa free", "brand new", "buy now", "buy with confidence",
    "Bacteriostatic", "BPA-Free", "bug", "Cancer", "Cancroid", "Cataract", "certified", "Chlamydia",
    "closeout", "CMV", "compostable", "Concusuion", "Coronavirus", "covid", "COVID-19", "Crabs",
    "Crystic Fibrosis", "Cytomegalovirus", "Chemical", "decomposable", "degradable", "Dementia",
    "Depression", "detoxification", "detoxify", "Diabetes", "Diabetic", "Diabetic Neuropathy",
    "Discounted price", "disease", "diseases", "don’t miss out", "dotoxifying",
    "depression or emotional health etc", "Doctor recommended", "Dustproof", "Disinfect", "diagnose",
    "eco-friendly", "environmentally friendly", "etc.", "Environment friendly",
    "Environmental Protection.", "fall sale", "fda", "FDA Approval", "FedEx", "filter", "flawless",
    "Flu", "free gift", "free shipping", "Filter air", "Free shipping Guaranteed", "fungal",
    "Fungicide", "Fungicides", "fungus", "gift idea", "Glaucoma", "Gororrhea", "Great as", "Great for",
    "green", "guarantee", "guaranteed", "Hassle free", "heal", "Hepatitis A", "Hepatitis B",
    "Hepatitis C", "Herpes", "Herpes Simplex Virus 1", "Herpes Simplex Virus 2", "highest rated",
    "HIV", "Hodgkins Lymphoma", "home compostable", "hot item", "HPV", "HSV1", "HSV2", "huge sale",
    "Human Immunodeficiency Virus", "Human Papiloma Virus", "Hygience", "Healthy", "Hypoallergenic",
    "Harmless", "imported from", "indian", "inflammation", "Influenza", "lnsect prevention", "insects",
    "Insecticidal", "Insecticide", "Insect repellent", "Inhibit-Algae", "Kidney Disease",
    "Lasting quality", "LGV", "limited time offer", "Liver disease", "Lupus", "Lymphogranuloma Venereum",
    "Lymphoma", "Made in", "mail rebate", "make excellent", "makes awesome", "makes great",
    "makes perfect", "makes spectacular", "makes the best", "makes wonderful", "marine degradable",
    "massive sale", "Meningitis", "mildew", "money back guarantee", "Mono", "Mononucleosis", "mould",
    "mould resistant", "mould spores", "Multiple Sclerosis", "Muscular Dystrophy",
    "Mycoplasma Genitalium", "Medical", "mites", "Mildew proof", "mosquitos", "mitigating any pest",
    "Micro-bio", "Moisture", "native american", "Native American Indian or tribes", "natural",
    "newest version", "NGU", "non toxic", "noncorrosive", "Nongonococcal Urethritis", "non-toxi",
    "non-toxic", "now together", "Nontoxic", "Non-poisonous", "Non-injurious", "Nano Silver",
    "over- stock", "On sale", "parasitic", "Parkinson", "Parkinsons", "patented", "peal",
    "Pelvic Inflammatory Disease", "Perfect for", "Perfect gift", "pesticide", "pesticides", "PID",
    "platinum", "plus free", "Professional quality", "proven", "Public lice", "perfect", "Prescription",
    "Pharmaceutical grade", "Prevent or inhibit the growth of bacteria", "quality",
    "Ready to ship", "recommended by", "remedies", "remedy", "Retail box", "Rehabilitate",
    "Resistant for mosquitoes & ants", "Remove allergens", "Repel insects",
    "Repel or slow down any pest", "Repel-Pesticides", "Resist ultraviolet rays", "Residue", "SAD",
    "sanitize", "sanitizes", "Satisfaction", "Save $", "Save cash", "Save money", "scabies",
    "Seasonal Affective Disorder", "seen on tv", "Ships faster", "shop with confidence", "Special offer",
    "Special promo", "spring sale", "Stroke", "summer sale", "super sale", "supplies won’t last",
    "Surgery", "Sterilization", "Sterilize", "Stop-MicrobelMildew", "TBIs", "tested", "The Clap",
    "Top notch", "top quality", "top rated", "top selling", "toxic", "toxin", "toxins",
    "Traumatic Brain Injuries", "treatment", "tribes", "Trich", "trichomoniasis", "tricht",
    "Tumor", "unbeatable price", "UPS", "Used", "Ultraviolet/uv", "validated", "viral", "virus",
    "viruses", "weight loss", "wholesale price", "winter sale", "Within hours", "worlds best",
    "Waterproof", "Water filtration"]
title_describe_base.push(all_mgc)

const preselection = [
    {
        name: "站内信敏感词检测",
        text: "review, evaluation, comment, feedback, rating, star positive, negative, critical, bad, level, appraise amend, change, modify, alter, withdraw, retract, edit, remove, delete, update, revise, erase, cancel, wipe out"
    },
    {
        name: "标题五点敏感词检测",
        text: [...title_describe_base].join(","),
        key_point: ["hemp","cbd","chondroitin","treat","cure","prevent"].join(",")
    }
]

export default preselection
